import Cookies from "js-cookie";
import { createActionType, createAsyncAction } from "./create-actions";

export const ADD_NEWS = createActionType("ADD_NEWS");
export const GET_NEWS = createActionType("GET_NEWS");
export const GET_NEWS_BY_ID = createActionType("GET_NEWS_BY_ID");
export const EDIT_NEWS = createActionType("EDIT_NEWS");
export const REMOVE_NEWS = createActionType("REMOVE_NEWS");

export const addNews = (data: any) =>
  createAsyncAction(ADD_NEWS, "/news/add_new_news", "post", data, {
    Authorization: `Bearer ${Cookies.get("token")}`,
  });

export const getNews = () =>
  createAsyncAction(GET_NEWS, "/news/get_all_news/cpanel", "get", undefined);

export const getNewsById = (data: any) =>
  createAsyncAction(
    GET_NEWS_BY_ID,
    `/news/get_news_by_id/${data}`,
    "get",
    undefined
  );

export const editNews = (id: string, data: any) =>
  createAsyncAction(EDIT_NEWS, `/news/edit_news_by_id/${id}`, "put", data, {
    Authorization: `Bearer ${Cookies.get("token")}`,
  });

export const removeNews = (id: string) =>
  createAsyncAction(
    REMOVE_NEWS,
    `/news/remove_news_by_id/${id}`,
    "delete",
    undefined,
    {
      Authorization: `Bearer ${Cookies.get("token")}`,
    }
  );
